/* SABAT theme — theme.js (no dependencies) */
(function () {
  'use strict';

  var S = window.Sabat || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' } };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Money ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || S.moneyFormat || 'Rs.{{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    function fmt(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return '0';
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return match ? format.replace(match[0], value) : value;
  }

  /* ---------------- Focus trap + drawers ---------------- */
  var overlay = $('[data-overlay]');
  var openDrawer = null;
  var lastFocus = null;

  function focusable(el) {
    return $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', el)
      .filter(function (n) { return n.offsetParent !== null; });
  }

  function showDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return false;
    if (openDrawer && openDrawer !== drawer) hideDrawer(true);
    lastFocus = document.activeElement;
    openDrawer = drawer;
    overlay.hidden = false;
    requestAnimationFrame(function () {
      overlay.classList.add('is-visible');
      drawer.classList.add('is-open');
    });
    document.body.classList.add('is-locked');
    setTimeout(function () { (focusable(drawer)[0] || drawer).focus(); }, 60);
    return true;
  }

  function hideDrawer(silent) {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open');
    openDrawer = null;
    if (!silent) {
      overlay.classList.remove('is-visible');
      document.body.classList.remove('is-locked');
      setTimeout(function () { if (!openDrawer) overlay.hidden = true; }, 300);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (showDrawer(opener.getAttribute('data-drawer-open'))) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) hideDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      hideDrawer();
      closeSearch();
    }
    if (e.key === 'Tab' && openDrawer) {
      var items = focusable(openDrawer);
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------------- Dialogs (size guide, quick add) ---------------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-dialog-open]');
    if (open) {
      var d = document.getElementById(open.getAttribute('data-dialog-open'));
      if (d && d.showModal) { e.preventDefault(); d.showModal(); }
      return;
    }
    if (e.target.closest('[data-dialog-close]')) {
      var dlg = e.target.closest('dialog');
      if (dlg) dlg.close();
      return;
    }
    if (e.target.tagName === 'DIALOG') {
      var r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.target.close();
    }
  });

  /* ---------------- Announcement rotator ---------------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2 || reduceMotion) return;
    var i = 0;
    var speed = (parseInt(bar.getAttribute('data-speed'), 10) || 5) * 1000;
    var timer = setInterval(next, speed);
    function next() {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }
    bar.addEventListener('mouseenter', function () { clearInterval(timer); });
    bar.addEventListener('mouseleave', function () { timer = setInterval(next, speed); });
  });

  /* ---------------- Search + predictive ---------------- */
  var searchPanel = $('[data-search-panel]');
  function closeSearch() { if (searchPanel && !searchPanel.hidden) searchPanel.hidden = true; }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-search-toggle]') || !searchPanel) return;
    e.preventDefault();
    searchPanel.hidden = !searchPanel.hidden;
    if (!searchPanel.hidden) setTimeout(function () { $('[data-predictive-input]', searchPanel).focus(); }, 30);
  });

  var predictiveInput = $('[data-predictive-input]');
  var predictiveResults = $('[data-predictive-results]');
  if (predictiveInput && predictiveResults) {
    var t;
    var ctrl;
    predictiveInput.addEventListener('input', function () {
      clearTimeout(t);
      var q = predictiveInput.value.trim();
      if (q.length < 2) { predictiveResults.innerHTML = ''; return; }
      t = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = new AbortController();
        var url = (S.routes.search || '/search/suggest') + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,tag,vendor&section_id=predictive-search';
        fetch(url, { signal: ctrl.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var section = doc.querySelector('.shopify-section') || doc.body;
            predictiveResults.innerHTML = section.innerHTML;
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* ---------------- Cart ---------------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.setAttribute('data-count', count);
      el.textContent = count > 0 ? count : '';
    });
  }

  function renderDrawer(sectionsHtml) {
    if (!sectionsHtml || !sectionsHtml['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sectionsHtml['cart-drawer'], 'text/html');
    var fresh = doc.querySelector('[data-cart-inner]');
    var current = $('[data-cart-inner]');
    if (fresh && current) {
      current.replaceWith(fresh);
      updateCount(parseInt(fresh.getAttribute('data-item-count'), 10) || 0);
      loadCartRecs(fresh);
    }
  }

  function addToCart(form, button) {
    var errorEl = $('[data-form-error]', form);
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    if (button) button.classList.add('is-loading');
    var body = new FormData(form);
    if (button && button.name === 'id' && button.value) body.set('id', button.value);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', window.location.pathname);

    return fetch(S.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) {
          var msg = res.description || res.message || 'This item could not be added.';
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
          else alert(msg);
          return;
        }
        var qd = document.getElementById('QuickAdd');
        if (qd && qd.open) qd.close();
        var card = form.closest('[data-card]');
        if (card) {
          if (button) { button.classList.add('is-added'); setTimeout(function () { button.classList.remove('is-added'); }, 1200); }
          setTimeout(function () { closeCard(card); }, 350);
        }
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        renderDrawer(res.sections);
        showDrawer('CartDrawer');
      })
      .catch(function () {
        if (errorEl) { errorEl.textContent = 'Connection lost. Check your internet and try again.'; errorEl.hidden = false; }
      })
      .finally(function () { if (button) button.classList.remove('is-loading'); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = e.submitter || $('[type="submit"]', form);
    addToCart(form, btn);
  });

  function changeLine(key, quantity, lineEl) {
    if (lineEl) lineEl.classList.add('is-updating');
    return fetch(S.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) {
          alert(res.description || res.message || 'Quantity could not be updated.');
          if (lineEl) lineEl.classList.remove('is-updating');
          return;
        }
        if ($('[data-cart-page]')) { window.location.reload(); return; }
        renderDrawer(res.sections);
      })
      .catch(function () { if (lineEl) lineEl.classList.remove('is-updating'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    changeLine(btn.getAttribute('data-line-change'), parseInt(btn.getAttribute('data-qty'), 10), btn.closest('.cart-item'));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-input]');
    if (!input) return;
    var q = Math.max(0, parseInt(input.value, 10) || 0);
    changeLine(input.getAttribute('data-line-input'), q, input.closest('.cart-item'));
  });

  /* ---------------- Quantity steppers (product form) ---------------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input');
    var v = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, v);
  });

  /* ---------------- Variant picker ---------------- */
  function initProductRoot(root) {
    if (root.__sabat) return;
    root.__sabat = true;
    var jsonEl = $('[data-variants]', root);
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var isQuick = root.getAttribute('data-uid') === 'quick';
    var section = root.closest('[data-product-section]') || root.closest('.quick') || document;
    var idInput = $('[data-variant-id]', root);
    var addBtn = $('[data-add-button]', root);
    var addLabel = $('[data-add-label]', root);
    var stockEl = $('[data-stock]', root);
    var waLink = $('[data-whatsapp]', root);
    var fieldsets = $$('[data-option]', root);
    var lowStock = parseInt(document.documentElement.getAttribute('data-low-stock'), 10) || 5;

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function markAvailability(opts) {
      fieldsets.forEach(function (fs, index) {
        $$('input', fs).forEach(function (input) {
          var test = opts.slice();
          test[index] = input.value;
          var ok = variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return o === test[i]; });
          });
          input.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function update() {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, i) {
        var label = $('[data-option-label]', fs);
        if (label) label.textContent = opts[i] || '';
      });
      markAvailability(opts);
      var v = findVariant(opts);

      if (!v) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        if (stockEl) stockEl.textContent = '';
        return;
      }

      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to bag' : 'Sold out';

      var priceEl = $('[data-price]', section);
      if (priceEl) {
        var html = '<div class="price-wrap">';
        if (v.compare > v.price) {
          html += '<span class="price price--sale">' + formatMoney(v.price) + '</span>' +
            '<s class="price price--compare">' + formatMoney(v.compare) + '</s>' +
            '<span class="price__save">Save ' + formatMoney(v.compare - v.price) + '</span>';
        } else {
          html += '<span class="price">' + formatMoney(v.price) + '</span>';
        }
        priceEl.innerHTML = html + '</div>';
      }

      if (stockEl) {
        stockEl.textContent = (v.tracked && v.qty > 0 && v.qty <= lowStock) ? 'Only ' + v.qty + ' left' : '';
      }

      if (waLink) {
        var text = 'Hi Sabat, I would like to order: ' + root.getAttribute('data-title') +
          (v.title !== 'Default Title' ? ' (' + v.title + ')' : '') + ' ' +
          waLink.getAttribute('data-origin') + root.getAttribute('data-url') + '?variant=' + v.id;
        waLink.href = 'https://wa.me/' + waLink.getAttribute('data-whatsapp') + '?text=' + encodeURIComponent(text);
      }

      if (!isQuick) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());

        if (v.media) {
          var item = $('[data-media-id="' + v.media + '"]', section);
          var gallery = $('[data-gallery]', section);
          if (item && gallery) scrollGalleryTo(gallery, item);
        }

        var sVariant = $('[data-sticky-variant]', section);
        if (sVariant) {
          sVariant.innerHTML = (v.title !== 'Default Title' ? escapeHtml(v.title) + ' &nbsp;' : '') + '<span data-sticky-price>' + formatMoney(v.price) + '</span>';
        }
        var sBtn = $('[data-sticky-add]');
        if (sBtn) {
          sBtn.disabled = !v.available;
          sBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
        }
      } else {
        var quickImg = $('.quick__media img', section);
        if (quickImg && v.image) { quickImg.removeAttribute('srcset'); quickImg.src = v.image.replace(/width=\d+/, 'width=900'); }
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) update();
    });
    markAvailability(selectedOptions());
  }

  function initProducts(ctx) { $$('[data-product-root]', ctx).forEach(initProductRoot); }
  initProducts(document);

  /* ---------------- Gallery progress (mobile swipe) ---------------- */
  $$('[data-gallery]').forEach(function (gallery) {
    var bar = gallery.parentElement.querySelector('[data-gallery-bar]');
    if (!bar) return;
    var ticking = false;
    gallery.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
        bar.style.transform = 'translateX(' + (i * 100) + '%)';
        ticking = false;
      });
    }, { passive: true });
  });

  /* ---------------- Lightbox with zoom ---------------- */
  $$('[data-lightbox]').forEach(function (dialog) {
    var track = $('[data-lightbox-track]', dialog);
    var items = $$('[data-lightbox-item]', dialog);
    var indexEl = $('[data-lightbox-index]', dialog);
    var section = dialog.closest('.shopify-section') || document;
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function unzoom(item) {
      var img = $('img', item);
      item.classList.remove('is-zoomed');
      if (img) img.style.width = '';
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-lightbox-open]');
      if (!opener || !dialog.showModal) return;
      if (!section.contains(opener) && $$('[data-lightbox]').length > 1) return;
      e.preventDefault();
      var index = parseInt(opener.getAttribute('data-lightbox-open'), 10) || 0;
      items.forEach(unzoom);
      dialog.showModal();
      document.body.classList.add('is-locked');
      var target = items[index];
      if (target) {
        $$('img', target).forEach(function (img) { img.loading = 'eager'; });
        track.scrollTop = target.offsetTop;
      }
      if (indexEl) indexEl.textContent = index + 1;
    });

    dialog.addEventListener('close', function () {
      document.body.classList.remove('is-locked');
      items.forEach(unzoom);
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && indexEl) indexEl.textContent = items.indexOf(en.target) + 1;
        });
      }, { root: track, threshold: 0.6 });
      items.forEach(function (item) { io.observe(item); });
    }

    items.forEach(function (item) {
      var img = $('img', item);
      if (!img) return;
      item.addEventListener('click', function (e) {
        if (item.classList.contains('is-zoomed')) { unzoom(item); return; }
        var rect = img.getBoundingClientRect();
        var rx = Math.min(Math.max((e.clientX - rect.left) / rect.width, 0), 1);
        var ry = Math.min(Math.max((e.clientY - rect.top) / rect.height, 0), 1);
        var zoomWidth = Math.max(rect.width * 2.2, item.clientWidth * 1.6);
        item.classList.add('is-zoomed');
        img.style.width = zoomWidth + 'px';
        requestAnimationFrame(function () {
          item.scrollLeft = rx * img.offsetWidth - item.clientWidth / 2;
          item.scrollTop = ry * img.offsetHeight - item.clientHeight / 2;
        });
      });
      if (finePointer) {
        item.addEventListener('mousemove', function (e) {
          if (!item.classList.contains('is-zoomed')) return;
          var r = item.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width;
          var py = (e.clientY - r.top) / r.height;
          item.scrollLeft = px * (img.offsetWidth - item.clientWidth);
          item.scrollTop = py * (img.offsetHeight - item.clientHeight);
        });
      }
    });
  });

  /* ---------------- Sticky add to bag ---------------- */
  var sticky = $('[data-sticky-atc]');
  if (sticky) {
    var mainForm = $('[data-product-section] .pform__form');
    var mainBtn = mainForm && $('[data-add-button]', mainForm);
    if (mainBtn && 'IntersectionObserver' in window) {
      var footer = $('.footer');
      var pastButton = false, footerVisible = false;
      var sync = function () {
        var show = pastButton && !footerVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $('[data-sticky-add]', sticky).tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        pastButton = !en.isIntersecting && en.boundingClientRect.top < 0;
        sync();
      }).observe(mainBtn);
      if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; sync(); }).observe(footer);

      $('[data-sticky-add]', sticky).addEventListener('click', function () {
        addToCart(mainForm, this);
      });
    }
  }

  /* ---------------- Quick add ---------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-add]');
    if (!trigger) return;
    e.preventDefault();
    var dialog = document.getElementById('QuickAdd');
    var body = $('[data-quick-add-body]', dialog);
    trigger.classList.add('is-loading');
    fetch(trigger.getAttribute('data-quick-add') + '?view=quick')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        body.innerHTML = html;
        initProducts(body);
        if (openDrawer) hideDrawer();
        dialog.showModal();
      })
      .catch(function () { window.location.href = trigger.getAttribute('data-quick-add'); })
      .finally(function () { trigger.classList.remove('is-loading'); });
  });

  /* ---------------- Product recommendations ---------------- */
  function loadSection(el, onEmpty, useFallback) {
    var url = el.getAttribute(useFallback ? 'data-fallback-url' : 'data-url');
    if (!url) { if (onEmpty) onEmpty(); return; }
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-recommendations]') || doc.querySelector('.shopify-section');
        var content = inner ? inner.innerHTML.trim() : '';
        if (content) {
          el.innerHTML = content;
          $$('[data-reveal]', el).forEach(function (r) { r.classList.add('is-revealed'); });
          $$('[data-carousel]', el).forEach(syncCarousel);
        } else if (!useFallback && el.hasAttribute('data-fallback-url')) {
          loadSection(el, onEmpty, true);
        } else if (onEmpty) onEmpty();
      })
      .catch(function () {});
  }

  var lazyObserver = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      obs.unobserve(en.target);
      loadSection(en.target, function () { en.target.hidden = true; });
    });
  }, { rootMargin: '0px 0px 400px 0px' }) : null;

  $$('[data-recommendations]').forEach(function (el) {
    if (!el.hasAttribute('data-url')) return;
    if (lazyObserver) lazyObserver.observe(el); else loadSection(el);
  });
  $$('[data-pairs]').forEach(function (el) { loadSection(el); });

  /* ---------------- Recently viewed ---------------- */
  var RV_KEY = 'sabat_recent';
  function readRecent() {
    try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (err) { return []; }
  }
  var productSection = $('[data-product-section]');
  if (productSection) {
    var handle = productSection.getAttribute('data-handle');
    var list = readRecent().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (err) {}
  }

  $$('[data-recently-viewed]').forEach(function (wrap) {
    var current = wrap.getAttribute('data-current');
    var limit = parseInt(wrap.getAttribute('data-limit'), 10) || 4;
    var handles = readRecent().filter(function (h) { return h !== current; }).slice(0, limit);
    if (!handles.length) return;
    var grid = $('[data-recently-grid]', wrap);
    Promise.all(handles.map(function (h) {
      return fetch(S.routes.root.replace(/\/$/, '') + '/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) return;
      grid.innerHTML = products.map(function (p) {
        var img = p.featured_image || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        var sale = p.compare_at_price > p.price;
        var colorOpt = (p.options || []).filter(function (o) { var n = (o.name || '').toLowerCase(); return n === 'color' || n === 'colour'; })[0];
        var fit = document.documentElement.getAttribute('data-img-fit') || 'contain';
        return '<li class="carousel__item"><article class="card" data-card>' +
          '<div class="card__media card__media--' + fit + '"><a class="card__link" href="' + p.url + '" tabindex="-1" aria-hidden="true">' +
          (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=700" alt="' + escapeHtml(p.title) + '" loading="lazy" width="700" height="875">' : '') + '</a></div>' +
          '<div class="card__info"><div class="card__row"><h3 class="card__title"><a href="' + p.url + '">' + escapeHtml(p.title) + '</a></h3>' +
          '<div class="card__price"><div class="price-wrap">' +
          (p.available === false ? '<span class="card__soldout">Sold out</span>' : (sale ? '<span class="price price--sale">' + formatMoney(p.price) + '</span><s class="price price--compare">' + formatMoney(p.compare_at_price) + '</s>' : '<span class="price">' + formatMoney(p.price) + '</span>')) +
          '</div></div></div>' +
          (colorOpt ? '<p class="card__sub">' + colorOpt.values.length + (colorOpt.values.length === 1 ? ' colour' : ' colours') + '</p>' : '') +
          '</div></article></li>';
      }).join('');
      wrap.hidden = false;
      $$('[data-carousel]', wrap).forEach(syncCarousel);
    });
  });

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- Collection sort ---------------- */
  $$('[data-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------------- Mega menu keyboard support ---------------- */
  $$('.site-nav__item').forEach(function (item) {
    var mega = $('.mega', item);
    if (!mega) return;
    var link = $('.site-nav__link', item);
    item.addEventListener('mouseenter', function () { link.setAttribute('aria-expanded', 'true'); });
    item.addEventListener('mouseleave', function () { link.setAttribute('aria-expanded', 'false'); });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) link.setAttribute('aria-expanded', 'false');
    });
  });

  /* ---------------- Gallery helpers + thumbnails ---------------- */
  function scrollGalleryTo(gallery, item) {
    var styles = getComputedStyle(gallery);
    var pad = parseFloat(styles.paddingLeft) || 0;
    gallery.scrollTo({ left: item.offsetLeft - pad, behavior: reduceMotion ? 'auto' : 'smooth' });
  }
  $$('[data-product-section]').forEach(function (sectionEl) {
    var gallery = $('[data-gallery]', sectionEl);
    var thumbs = $$('[data-thumb]', sectionEl);
    if (!gallery || !thumbs.length) return;
    var slides = Array.prototype.slice.call(gallery.children);
    var clicked = 0;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        clicked = parseInt(t.getAttribute('data-thumb'), 10) || 0;
        var slide = slides[clicked];
        if (slide) scrollGalleryTo(gallery, slide);
        thumbs.forEach(function (x, i) { x.classList.toggle('is-active', i === clicked); });
      });
    });
    var raf = false;
    gallery.addEventListener('scroll', function () {
      if (raf) return;
      raf = true;
      requestAnimationFrame(function () {
        raf = false;
        var pad = parseFloat(getComputedStyle(gallery).paddingLeft) || 0;
        var x = gallery.scrollLeft + pad + 2;
        var idx = 0;
        slides.forEach(function (sl, i) { if (sl.offsetLeft <= x) idx = i; });
        if (gallery.scrollLeft + gallery.clientWidth >= gallery.scrollWidth - 4) idx = Math.max(idx, clicked);
        idx = Math.min(idx, slides.length - 1);
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      });
    }, { passive: true });
  });

  /* ---------------- Card size panel ---------------- */
  function closeCard(card) {
    card.classList.remove('is-sizing');
    var t = $('[data-card-toggle]', card);
    if (t) t.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-card-toggle]');
    var openCards = $$('.card.is-sizing');
    if (toggle) {
      e.preventDefault();
      var card = toggle.closest('[data-card]');
      openCards.forEach(function (c) { if (c !== card) closeCard(c); });
      card.classList.add('is-sizing');
      toggle.setAttribute('aria-expanded', 'true');
      var firstSize = $('.card__size:not([disabled])', card);
      if (firstSize) setTimeout(function () { firstSize.focus({ preventScroll: true }); }, 300);
      return;
    }
    if (e.target.closest('[data-card-close]')) { closeCard(e.target.closest('[data-card]')); return; }
    openCards.forEach(function (c) { if (!c.contains(e.target)) closeCard(c); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.card.is-sizing').forEach(function (c) {
      closeCard(c);
      var t = $('[data-card-toggle]', c);
      if (t && c.contains(document.activeElement)) t.focus();
    });
  });

  /* ---------------- Product sliders ---------------- */
  function syncCarousel(carousel) {
    var track = $('[data-carousel-track]', carousel);
    if (!track) return;
    var prev = $('[data-carousel-prev]', carousel);
    var next = $('[data-carousel-next]', carousel);
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
    var nav = $('.carousel__nav', carousel);
    if (nav) nav.hidden = max <= 0;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;
    var carousel = btn.closest('[data-carousel]');
    var track = $('[data-carousel-track]', carousel);
    var item = track.firstElementChild;
    var step = item ? item.getBoundingClientRect().width + 2 : track.clientWidth * 0.8;
    var perView = Math.max(1, Math.floor(track.clientWidth / step));
    var dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
    track.scrollBy({ left: dir * step * perView, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-carousel-track]')) syncCarousel(t.closest('[data-carousel]'));
  }, true);
  $$('[data-carousel]').forEach(syncCarousel);
  window.addEventListener('resize', function () { $$('[data-carousel]').forEach(syncCarousel); });

  /* ---------------- Shop by category scroll ---------------- */
  $$('[data-activity]').forEach(function (section) {
    var bgs = $$('[data-activity-bg]', section);
    var links = $$('[data-activity-link]', section);
    var cta = $('[data-activity-cta]', section);
    var current = 0;
    function setActive(i) {
      if (i === current || !links[i]) return;
      current = i;
      bgs.forEach(function (b, n) { b.classList.toggle('is-active', n === i); });
      links.forEach(function (l, n) { l.classList.toggle('is-active', n === i); });
      if (cta) cta.href = links[i].getAttribute('href');
      var img = $('img', bgs[i]);
      if (img && img.loading === 'lazy') img.loading = 'eager';
    }
    links.forEach(function (l, i) { l.addEventListener('mouseenter', function () { setActive(i); }); l.addEventListener('focus', function () { setActive(i); }); });
    var ticking = false;
    function onScroll() {
      ticking = false;
      var r = section.getBoundingClientRect();
      var span = r.height - window.innerHeight;
      if (span <= 0 || r.bottom < 0 || r.top > window.innerHeight) return;
      var progress = Math.min(Math.max(-r.top / span, 0), 0.9999);
      setActive(Math.floor(progress * links.length));
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    $$('img', section).forEach(function (img, n) { if (n < 2) img.loading = 'eager'; });
  });



  /* ---------------- Return-to-cart reminder ---------------- */
  (function initCartReturn() {
    var peek = $('[data-cart-return]');
    var timing = $('[data-cart-return-away]');
    if (!peek || !timing) return;
    var awaySince = 0;
    var minimumAway = parseInt(timing.getAttribute('data-cart-return-away'), 10) || 15000;
    var hideTimer = null;

    function hidePeek() {
      peek.classList.remove('is-visible');
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function () { peek.hidden = true; }, 400);
    }
    function showPeek() {
      fetch(S.routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || !cart.item_count || openDrawer) return;
          var first = cart.items && cart.items[0];
          var media = $('[data-cart-return-media]', peek);
          var title = $('[data-cart-return-title]', peek);
          var meta = $('[data-cart-return-meta]', peek);
          var price = $('[data-cart-return-price]', peek);
          if (first) {
            if (media) { var src = first.image || ''; if (src) src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=160'; media.innerHTML = src ? '<img src="' + src + '" alt="" loading="lazy">' : ''; }
            if (title) title.textContent = first.product_title || first.title || 'Your item';
            if (meta) {
              var extra = cart.item_count > 1 ? ' + ' + (cart.item_count - 1) + ' more' : '';
              meta.textContent = (first.variant_title && first.variant_title !== 'Default Title' ? first.variant_title : '') + extra;
            }
            if (price) price.textContent = formatMoney(first.final_line_price || first.line_price || 0);
          }
          peek.hidden = false;
          requestAnimationFrame(function () { peek.classList.add('is-visible'); });
          window.clearTimeout(hideTimer);
          hideTimer = window.setTimeout(hidePeek, 9000);
        })
        .catch(function () {});
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { awaySince = Date.now(); return; }
      if (awaySince && Date.now() - awaySince >= minimumAway) showPeek();
      awaySince = 0;
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-return-close]')) { e.preventDefault(); hidePeek(); }
      if (e.target.closest('[data-cart-return] [data-drawer-open]')) hidePeek();
    });
  })();

  /* ---------------- Cart drawer recommendations ---------------- */
  function loadCartRecs(ctx) {
    $$('[data-cart-recs]', ctx || document).forEach(function (el) {
      loadSection(el, function () { var box = el.closest('.minis'); if (box) box.hidden = true; });
    });
  }
  loadCartRecs(document);

  /* ---------------- Header: overlay, solid state, hide on scroll ---------------- */
  var headerSection = $('.section-header');
  if (headerSection) {
    var root = document.documentElement;
    var measure = function () { root.style.setProperty('--header-offset', $('.site-header', headerSection).offsetHeight + 'px'); };
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(headerSection);
    else window.addEventListener('resize', measure);

    var lastY = window.scrollY;
    var pinned = false;
    var interacting = function () {
      return headerSection.matches(':focus-within') || (searchPanel && !searchPanel.hidden) || headerSection.__hover;
    };
    var syncHeader = function () {
      var y = window.scrollY;
      var busy = interacting() || !!openDrawer;
      headerSection.classList.toggle('is-solid', y > 8 || busy);
      var hide = !busy && y > lastY && y > Math.max(window.innerHeight * 0.6, 400);
      if (y < lastY - 4 || y < 200 || busy) hide = false;
      if (Math.abs(y - lastY) > 4 || busy) {
        headerSection.classList.toggle('is-hidden', hide);
        root.style.setProperty('--header-shown', hide ? '0' : '1');
        lastY = y;
      }
    };
    window.addEventListener('scroll', function () {
      if (pinned) return;
      pinned = true;
      requestAnimationFrame(function () { syncHeader(); pinned = false; });
    }, { passive: true });
    headerSection.addEventListener('mouseenter', function () { headerSection.__hover = true; syncHeader(); });
    headerSection.addEventListener('mouseleave', function () { headerSection.__hover = false; syncHeader(); });
    headerSection.addEventListener('focusin', syncHeader);
    headerSection.addEventListener('focusout', function () { setTimeout(syncHeader, 0); });
    document.addEventListener('click', function (e) { if (e.target.closest('[data-search-toggle]')) setTimeout(syncHeader, 0); });
    syncHeader();
  }

  /* ---------------- Announcement height (keeps full-screen hero on the fold) ---------------- */
  var announceSection = $('.section-announcement');
  if (announceSection) {
    var measureAnnounce = function () { document.documentElement.style.setProperty('--announce-h', announceSection.offsetHeight + 'px'); };
    measureAnnounce();
    window.addEventListener('resize', measureAnnounce);
  }

  /* ---------------- WhatsApp button waits until the hero is scrolled ---------------- */
  var waFloat = $('.wa-float');
  var firstHero = $('main > .shopify-section:first-child [data-overlay-header]');
  if (waFloat && firstHero) {
    var syncWa = function () { waFloat.classList.toggle('is-away', window.scrollY < window.innerHeight * 0.35); };
    syncWa();
    window.addEventListener('scroll', syncWa, { passive: true });
  }

  /* ---------------- Images fade in once loaded ---------------- */
  var FADE_SCOPE = ['.card__media', '.mgrid__media', '.activity__bg', '.story__media', '.look__media', '.gallery__item', '.coll-banner', '.mega__promo-media', '.article-card__media', '.article-hero', '.predictive__item', '.quick__media', '.cart-item__media', '.mini__media', '.look-item__media', '.style-with__media', '.mstrip__item', '.pdp__thumb', '.tile__media'].map(function (c) { return c + ' img'; }).join(', ');
  function watchImage(img) {
    if (img.__fade) return;
    img.__fade = true;
    var done = function () { img.classList.add('is-loaded'); };
    if (img.complete && img.naturalWidth !== 0) done();
    else {
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    }
  }
  function watchImages(ctx) {
    if (ctx.matches && ctx.matches(FADE_SCOPE)) watchImage(ctx);
    if (ctx.querySelectorAll) $$(FADE_SCOPE, ctx).forEach(watchImage);
  }
  document.documentElement.classList.add('img-fade');
  document.documentElement.setAttribute('data-img-fit', (getComputedStyle(document.documentElement).getPropertyValue('--img-fit') || 'contain').trim());
  watchImages(document);
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) watchImages(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ---------------- Editorial image reveal ---------------- */
  if ('IntersectionObserver' in window && !reduceMotion) {
    var revealEls = $$('[data-reveal]');
    if (revealEls.length) {
      var revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-revealed');
          revealIO.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -12% 0px' });
      revealEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.88) el.classList.add('is-revealed');
        else revealIO.observe(el);
      });
      document.documentElement.classList.add('reveal-ready');
    }
  }

  /* ---------------- Background videos: play only when visible ---------------- */
  $$('[data-autoplay-video], .hero__video').forEach(function (video) {
    video.muted = true;
    video.setAttribute('playsinline', '');
    if (reduceMotion) { video.removeAttribute('autoplay'); video.pause(); return; }
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        else video.pause();
      });
    }, { threshold: 0.05 }).observe(video);
  });

  /* Theme editor: re-init when sections reload */
  document.addEventListener('shopify:section:load', function (e) {
    initProducts(e.target);
    watchImages(e.target);
    $$('[data-reveal]', e.target).forEach(function (el) { el.classList.add('is-revealed'); });
  });
})();
